export enum ReservationState {
	unconfirmed = 'unconfirmed',
	approved = 'approved',
	rejected = 'rejected',
	seated = 'seated',
	done = 'done',
}
